<template>
  <b-card title="Manager">
    <div>
      <b-form ref="form" class="repeater-form" @submit.prevent="repeateAgain">
        <b-row ref="row" v-for="(item, index) in items" :key="item.id">
          <!-- Nom et Prénom -->
          <b-col md="6">
            <b-form-group label="Nom Prénom(s)" label-for="item-name">
              <v-select v-model="item.selectedUser" :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="userOptions" :reduce="option => option.id" label="fullName"
                @input="updateUserDetails(index)" />
            </b-form-group>
          </b-col>

          <!-- Fonction -->
          <b-col md="6">
            <b-form-group label="Fonction" label-for="readOnlyInput">
              <b-form-input id="readOnlyInput" v-model="item.fonction" readonly />
            </b-form-group>
          </b-col>

          <!-- Direction -->
          <b-col md="6">
            <b-form-group label="Direction" label-for="item-direction">
              <b-form-input id="item-direction" :value="item.directions ? item.directions.name : ''" readonly />
            </b-form-group>
          </b-col>

          <!-- Service -->
          <b-col md="5">
            <b-form-group label="Service" label-for="item-service">
              <b-form-input id="item-service" :value="item.services ? item.services.name : ''" readonly />
            </b-form-group>
          </b-col>

          <!-- Supprimer l'élément -->
          <b-col lg="1" md="1" class="mb-50">
            <b-button v-ripple.400="'rgba(234, 84, 85, 0.15)'" variant="outline-danger" class="mt-0 mt-md-2"
              @click="removeItem(index)">
              <feather-icon icon="XIcon" class="mr-25" />
            </b-button>
          </b-col>

          <b-col cols="12">
            <hr />
          </b-col>
        </b-row>
      </b-form>
    </div>

    <!-- Bouton Ajouter -->
    <b-button v-ripple.400="'rgba(255, 255, 255, 0.15)'" variant="primary" @click="repeateAgain">
      <feather-icon icon="PlusIcon" class="mr-25" />
      <span>Ajouter</span>
    </b-button>
  </b-card>
</template>
<script>
import { BForm, BFormGroup, BFormInput, BRow, BCol, BButton, BCard } from 'bootstrap-vue';
import Ripple from 'vue-ripple-directive';
import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';
import { getAllUser,getAllDisabledUsers } from '@/services/UserService';

export default {
  components: {
    vSelect,
    BCard,
    BForm,
    BRow,
    BCol,
    BButton,
    BFormGroup,
    BFormInput,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      items: [],
      nextTodoId: 1,
      userAll: [],
      filteredUserOptions: [],
      user: null,
    };
  },
  computed: {


    userOptions() {
    return this.userAll.filter(user => user.id !== this.user?.id).map(user => ({
      ...user,
      fullName: `${user.lastName} ${user.firstName}`,
    }));
  },
  },
  mounted() {
    this.fetchUsers();
  },
  methods: {
    fetchUsers() {
      getAllDisabledUsers(false)
        .then(users => {
          this.userAll = users;

        })
        .catch(error => {
          console.error('Erreur lors de la récupération des utilisateurs :', error);
        });

    },

    repeateAgain() {
      this.items.push({
        id: this.nextTodoId++,
        selectedUser: null,
        fonction: '',
        directions: null,
        services: null,
      });
    },
    removeItem(index) {
      // Supprime un élément à un index donné
      if (index >= 0 && index < this.items.length) {
        this.items.splice(index, 1);
      }
      this.$emit('update-hierarchy', [...this.items]); // Créer une copie pour éviter les mutations directes

    },
    updateUserDetails(index) {
      // Met à jour les détails de l'utilisateur sélectionné
      const item = this.items[index];
      if (!item || !item.selectedUser) {
        console.error('Utilisateur sélectionné invalide pour l\'index', index);
        return;
      }
      const selectedUser = this.userAll.find(user => user.id === item.selectedUser);

      if (selectedUser) {
        this.items[index] = {
          ...item,
          id: selectedUser.id || null,
          fonction: selectedUser.fonction || '',
          directions: selectedUser.directions || null,
          services: selectedUser.services || null,
        };

        this.$emit('update-hierarchy', [...this.items]); // Créer une copie pour éviter les mutations directes
      }

    },
    updateForm(data) {
      if (data?.usersHierarchique?.length) {
        this.items = data.usersHierarchique.map(user => ({
          id: this.nextTodoId++,
          selectedUser: user.id,
          fonction: user.fonction,
          directions: user.directions || null,
          services: user.services || null,
        }));
        this.user=data;

      } else {
        this.items = [];
      }
    },
    reset() {
      this.items = [];
      this.nextTodoId = 1;
    },
  },
};
</script>
